import { render } from "./activitiesDetailPanel.vue?vue&type=template&id=7baf7272&scoped=true"
import script from "./activitiesDetailPanel.vue?vue&type=script&lang=js"
export * from "./activitiesDetailPanel.vue?vue&type=script&lang=js"

import "./activitiesDetailPanel.vue?vue&type=style&index=0&id=7baf7272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baf7272"]])

export default __exports__